import { render } from "./HomepageBottomToolbar.vue?vue&type=template&id=6effafc6&scoped=true"
import script from "./HomepageBottomToolbar.vue?vue&type=script&lang=js"
export * from "./HomepageBottomToolbar.vue?vue&type=script&lang=js"

import "./HomepageBottomToolbar.vue?vue&type=style&index=0&id=6effafc6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6effafc6"]])

export default __exports__